<div class="actions-container">
  @for (action of actions; track action.name) {
    <p class="action-button" (click)="action.actionFn()" class="url {{ action.cssClass }}" matTooltip="{{ action.name | bmsTranslate }}">
      {{ action.name | bmsTranslate }}
    </p>
  }
</div>
